import React, { useState, useEffect } from 'react'

import {
  ProgressBar
} from 'react-bootstrap';

import _ from 'lodash';
import cx from 'classnames';
import { IKImage } from "imagekitio-react";
import dateformat from "dateformat";

import Tooltip from 'components/Tooltip';
import storyboardRoleService from 'services/storyboardRoles.service';
import { useSelector } from 'react-redux';

import styles from './components.module.scss';
import FileService from 'services/file.service';
import Truncate from 'react-truncate';
import { DEFAULT, DOCUMENT, VIDEO } from 'constants/widgetAssetTypes';
import { INTERACTIVE_CONTENT_TYPES } from 'constants/storyboardType';

const defaultContentImage = '/public/cleverstory/v2/static/default_card.jpg';

export const ContentCard = ({ assetMapping, key, id, selected, onClick, allowType}) => {

  const icon = _.get(assetMapping, 'asset.icon.key', null) || _.get(assetMapping, 'asset.icon.url', null);
  const gatingConfigurations = _.get(assetMapping, 'gatingConfigurations');
  const [tooltip, setTooltip] = useState(false)
  const metaData = _.get(assetMapping, 'asset.metadata');
  const fileType = _.get(assetMapping, 'asset.metadata.content_type');
  const uploading = _.get(assetMapping, 'uploading');
  const updating = _.get(assetMapping, 'updating');
  const creating = _.get(assetMapping, 'creating') || _.get(assetMapping, 'creatingAssetMapping');
  const optimizing = _.get(assetMapping, 'asset.entityType') === "asset" && 
  (_.get(assetMapping, 'asset.status') != "ok" &&
   _.get(assetMapping, 'asset.status') != "OK");
  const deleting = _.get(assetMapping, 'deleting');
  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard.item", null));

  let isFileTypeIncluded = checkTypes(metaData, allowType);

  const progress = uploading || creating || optimizing;

  const handleAssetSection = (e) => {
    if( isFileTypeIncluded ){
     
      const id = _.get(assetMapping, 'id', null);
      const type = _.get(assetMapping, 'entityType', null);
      if (!id || deleting) {
        return;
      }

      onClick(e, assetMapping);
    }
  }

  const renderAssetName = () => {
    const type = _.get(assetMapping, 'entityType');

    switch (type) {
      case 'asset':
        return _.get(assetMapping, 'asset.name', '');
      case 'url':
        return _.get(assetMapping, 'url', '');
      case 'file':
        return _.get(assetMapping, 'file.name', '');
      case 'page':
        return _.get(assetMapping, 'asset.name', '');
      default:
        return "";
    }
  }

  const name = renderAssetName();

  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }

  const renderAdditionalData = () => {
    const pages = _.get(metaData, 'pages');

    if (pages) {
      return `${pages} Page${pages == 1 ? '' : 's'}`
    }

    return FileService.fileType(metaData);
  }
  return (
    <div key={key} id={id} onClick={handleAssetSection} className={cx(styles.assetCardWrapper, 'cs-asset-card', { ['cs-selected-asset-card']: selected }, {
      [styles.selected]: selected
    }, { [styles.isDisabled]: !isFileTypeIncluded }, {[styles.disabled]: !storyboardRoleService.canEditStoryboard(storyboard)} )}>
      {progress &&
        <div className={styles.overlay}>
          {uploading &&
            <ProgressBar variant="warning" className={styles.progressLoader} now={assetMapping.progress} />
          }

          {creating &&
            <div className={styles.creating}>Processing...</div>
          }

          {!uploading && !creating && optimizing &&
            <div className={styles.optimizing}>Optimizing...</div>
          }
        </div>
      }

      {deleting && 
        <div className={styles.overlay}>
          <span className={styles.deleting} >deleting...</span>
        </div>
      }

      {updating &&
        <div className={styles.overlay}>
          {fileType !== "application/url" &&
            <ProgressBar variant="warning" className={styles.progressLoader} now={assetMapping.progress} />
          }

          {fileType === "application/url" && 
            <div className={styles.optimizing}>Updating...</div>
          }
        </div>
      }

      <div className={styles.iconWrapper}>
        {(icon || defaultContentImage) && 
          <IKImage
          className={styles.icon}
          path={icon || defaultContentImage}
        />
        }
        {_.size(gatingConfigurations) > 0 && gatingConfigurations.some(g => g.enabled) &&
          <i className={cx(styles.lockIcon, `cleverstory-lock`)} />
        }
      </div>
      <div className={styles.detailsContainer}>
        {name &&
          <Tooltip placement="top" content={name} disabled={!tooltip} className={styles.tooltip}>
            <span className={styles.name}>
              <Truncate onTruncate={handleTooltip} lines={1}>
                  {name}
              </Truncate>
            </span>
          </Tooltip>
        }
        <ContentMetadata content={assetMapping} />
      </div>
    </div>
  )
}

export const ContentMetadata = ({ content, className }) => {
  const metaData = _.get(content, 'asset.metadata', {})
  let fileMetaData = FileService.fileMetaData(metaData);
  const assetSource = _.get(content, 'asset.source');

  const modified_date = _.get(content, 'modifiedDate') || _.get(metaData, 'modified_date');

  let storyboardType = _.get(content, 'asset.storyboardType');
  
  const renderStoryboardType = (type) => {
    if (type === 'LANDING_PAGE') {
      return 'Landing page';
    } else if (INTERACTIVE_CONTENT_TYPES.includes(type)) {
      return 'Interactive content';
    } else if (type === 'RESOURCE_CENTER') {
      return 'Resource center';
    } else if (type === 'SPATIAL') {
      return 'Spatial';
    } else {
      return 'Flipbook'
    }
  }

  return (
    <div className={styles.metaData}>
      <div className={styles.details}>
        <div className={styles.type}>
          {(_.get(content, 'asset.entityType') === 'asset' || _.get(content, 'entityType') === 'asset' ) &&
            <>
              <i className={cx(styles.fileIcon, `${FileService.fileIcon(metaData)}`)} />
              <span className={styles.textFormat} >{FileService.fileType(metaData)}</span>
            </>
          }
          {(_.get(content, 'asset.entityType') === 'page' || _.get(content, 'entityType') === 'page' ) &&
            <>
              <i className={cx(styles.fileIcon, `${FileService.storyboardIcon(storyboardType)}`)} />
              <span className={styles.storyboardTextFormat} >{renderStoryboardType(storyboardType)}</span>
            </>
          }
        </div>
        {fileMetaData && <i className={styles.seperator}></i>}
        {fileMetaData && <span className={styles.contentMetadata}>{fileMetaData}</span>}
      </div>
      <span className={styles.date}>Updated:{dateformat(modified_date, 'dd mmm yyyy')}</span>
    </div>
  );
}

export const ContentCardPlaceholder = () => {
  return (
    <div className={cx(styles.contentCard, styles.placeholder)}>
      <div className={cx(styles.iconWrapper)}></div>
      <div className={styles.detailsContainer}>
        <div className={styles.name}>
          <span>&nbsp;</span>
          <span>&nbsp;</span>
        </div>
        <div className={cx(styles.contentMetadata)}>
          {_.times(2).map(index => {
            return (
              <div key={index} className={styles.metadata}><span>&nbsp;</span></div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

function checkTypes(metaData, allowType) {
  const videoTypes = ["VIDEO", "YOUTUBE", "VIMEO", "WISTIA", "VIDYARD", "WMV"];
  const documentTypes = ["PDF", "PPTX", "PPT", "DOC", "DOCX"];
  
  if (!metaData || !allowType) {
    return true;
  }

  const file_type = FileService.fileType(metaData);

  const isVideo = allowType === VIDEO || allowType === DEFAULT;
  const isDocument = allowType === DOCUMENT;

  if (isVideo) {
    return videoTypes.includes(file_type);
  } else if (isDocument) {
    return documentTypes.includes(file_type);
  } else {
    return true;
  }
}


